// SS Mega Menu fix - debug + clamp
window.__SS_MENU_FIX__ = 'loaded-before-iife';

(function () {
  try {
    var EDGE = 24;  // gutter from viewport edge
    var GAP  = 6;   // gap under the top item
    var MAXW = 1100;

    function closestTopItem(el) {
      while (el && el !== document) {
        if (el.classList && el.classList.contains('ss-top__item')) return el;
        el = el.parentNode;
      }
      return null;
    }

    function findDropdown(item) {
      return item ? item.querySelector('.ss-dropdown') : null;
    }

    function setFixedPosition(item) {
      var dd = findDropdown(item);
      if (!dd) return;

      var prevDisplay = dd.style.display;
      var prevVisibility = dd.style.visibility;

      dd.style.display = 'block';
      dd.style.visibility = 'hidden';

      var itemRect = item.getBoundingClientRect();
      var vw = window.innerWidth || document.documentElement.clientWidth;

      var w = Math.min(MAXW, vw - (EDGE * 2));
      if (w < 240) w = Math.max(200, vw - 20);

      var idealLeft = (itemRect.left + itemRect.width / 2) - (w / 2);
      var left = Math.max(EDGE, Math.min(idealLeft, vw - EDGE - w));

      dd.style.position = 'fixed';
      dd.style.left = left + 'px';
      dd.style.right = 'auto';
      dd.style.top = (itemRect.bottom + GAP) + 'px';
      dd.style.transform = 'none';
      dd.style.width = w + 'px';
      dd.style.maxWidth = w + 'px';
      dd.style.zIndex = '9999';

      dd.style.visibility = prevVisibility || '';
      dd.style.display = prevDisplay || '';
    }

    function reset(item) {
      var dd = findDropdown(item);
      if (!dd) return;
      dd.style.position = '';
      dd.style.left = '';
      dd.style.right = '';
      dd.style.top = '';
      dd.style.transform = '';
      dd.style.width = '';
      dd.style.maxWidth = '';
      dd.style.zIndex = '';
    }

    var currentItem = null;

    function onOver(e) {
      var item = closestTopItem(e.target);
      if (!item) return;
      if (item === currentItem) return;
      currentItem = item;
      setFixedPosition(item);
    }

    function onOut(e) {
      if (!currentItem) return;
      var related = e.relatedTarget;
      if (related && closestTopItem(related) === currentItem) return;
      reset(currentItem);
      currentItem = null;
    }

    function onFocus(e) {
      var item = closestTopItem(e.target);
      if (!item) return;
      currentItem = item;
      setFixedPosition(item);
    }

    function onBlur(e) {
      if (!currentItem) return;
      var related = e.relatedTarget;
      if (related && closestTopItem(related) === currentItem) return;
      reset(currentItem);
      currentItem = null;
    }

    function onResizeOrScroll() {
      if (currentItem) setFixedPosition(currentItem);
    }

    function bind() {
      document.addEventListener('mouseover', onOver, true);
      document.addEventListener('mouseout', onOut, true);
      document.addEventListener('focusin', onFocus, true);
      document.addEventListener('focusout', onBlur, true);
      window.addEventListener('resize', onResizeOrScroll);
      window.addEventListener('scroll', onResizeOrScroll, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }

    window.__SS_MENU_FIX__ = 'v3-fixed-clamp';
    console.log('[SS MENU FIX] running:', window.__SS_MENU_FIX__);

  } catch (err) {
    window.__SS_MENU_FIX__ = 'error';
    console.error('[SS MENU FIX] crashed:', err);
  }
})();
